import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import contestCardPropType from '../../propTypes/contestCard';
import config from '../../config';

const getContestCardClassnames = large => classnames({
  'sl-contest-card': true,
  'sl-contest-card--large': large,
});

const ContestCard = ({ contest, large }) => (
  <a
    href={`/${config.baseContestUrl(contest.region, contest.period)}`}
    className={getContestCardClassnames(large)}
  >
    <div className="sl-contest-card__top">{contest.abbreviation}</div>
    <div className="sl-contest-card__image">
      <div style={{ backgroundImage: `url(${contest.imageUrl})` }} />
    </div>
    <h6 className="sl-contest-card__name">{contest.name}</h6>
  </a>
);

ContestCard.propTypes = {
  contest: contestCardPropType.isRequired,
  large: PropTypes.bool,
};

ContestCard.defaultProps = {
  large: false,
};

export default ContestCard;
